import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceChangeType } from "../../constants/priceChangeType"
import { SubAreaModel } from "../subAreaModel"

@Serializable
export class PriceLogBaseModel {
  uid: string = ""
  changeType: PriceChangeType = PriceChangeType.Undefined
  created: string = ""
  createdByName: string = ""
  createdByEmail: string = ""
  comment: string = ""
  subAreasFrom: SubAreaModel[] = []
  subAreasTo: SubAreaModel[] = []

  constructor(
    data: {
      uid: string
      changeType: number
      created: string
      createdByName: string
      createdByEmail: string
      comment: string
      subAreasFrom: SubAreaModel[]
      subAreasTo: SubAreaModel[]
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.changeType = data.changeType
      this.created = data.created
      this.createdByName = data.createdByName
      this.createdByEmail = data.createdByEmail
      this.comment = data.comment
      this.subAreasFrom = data.subAreasFrom
      this.subAreasTo = data.subAreasTo
    }
  }
}
